import React from "react"

const CommitteeContext = React.createContext({})

export default CommitteeContext
